import React, { useMemo } from 'react';
import { Button, Tree } from 'antd';

/**
 * 全景影像二级菜单：项目→场景树 + 管理
 * 宽度 ≈ 最长文案 + 1 个字宽；内容左对齐
 */
export default function PanoramaKindMenu({
  projects = [],
  canManage = false,
  busy = false,
  onOpenManage,
  onOpenProject,
  onOpenScene
}) {
  const { treeData, menuWidthEm } = useMemo(() => {
    const texts = ['管理'];
    const data = (projects || []).map((p) => {
      const scenes = p.scenes || [];
      const statusBit = p.status === 'published' ? '' : `(${p.status || 'draft'})`;
      const countBit = ` ${scenes.length || p.sceneCount || 0}景`;
      const projectLabel = `${p.title || `项目 #${p.id}`}${statusBit}${countBit}`;
      texts.push(projectLabel);
      return {
        key: `p-${p.id}`,
        title: (
          <button
            type="button"
            className="zhxt-ortho-kind-item-name"
            title="打开全景项目"
            onClick={(e) => {
              e.stopPropagation();
              onOpenProject?.(p);
            }}
          >
            {p.title || `项目 #${p.id}`}
            <span className="zhxt-ortho-muted" style={{ marginLeft: 4 }}>
              {statusBit}
              {countBit}
            </span>
          </button>
        ),
        children: scenes.map((s) => {
          const sceneLabel = `${s.name || `场景 #${s.id}`}${!s.ossKey ? ' 未上传' : ''}`;
          texts.push(sceneLabel);
          return {
            key: `s-${s.id}`,
            isLeaf: true,
            title: (
              <button
                type="button"
                className="zhxt-ortho-kind-item-name"
                title={
                  s.ossKey
                    ? (Number.isFinite(Number(s.lon)) && Number.isFinite(Number(s.lat))
                      ? '打开该场景，并飞到其坐标'
                      : '打开该场景')
                    : '尚未上传全景图'
                }
                disabled={!s.ossKey && !canManage}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!s.ossKey) return;
                  onOpenScene?.(p, s);
                }}
              >
                {s.name || `场景 #${s.id}`}
                {!s.ossKey ? (
                  <span className="zhxt-ortho-muted" style={{ marginLeft: 4 }}>未上传</span>
                ) : null}
              </button>
            )
          };
        })
      };
    });
    const maxChars = texts.reduce((m, t) => Math.max(m, String(t).length), 4);
    return { treeData: data, menuWidthEm: maxChars + 1 };
  }, [projects, canManage, onOpenProject, onOpenScene]);

  return (
    <div
      className="zhxt-map-kind-menu zhxt-panorama-kind-menu"
      style={{ width: `${menuWidthEm}em` }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="zhxt-map-kind-menu-top zhxt-panorama-kind-menu-top">
        {canManage ? (
          <Button size="small" type="link" loading={busy} onClick={() => onOpenManage?.()}>
            管理
          </Button>
        ) : (
          <span className="zhxt-ortho-muted">仅可查看</span>
        )}
      </div>
      <div className="zhxt-ortho-kind-list zhxt-panorama-kind-list">
        {treeData.length === 0 ? (
          <div className="zhxt-ortho-muted" style={{ padding: '4px 0' }}>
            暂无全景项目
          </div>
        ) : (
          <Tree
            defaultExpandAll
            selectable={false}
            treeData={treeData}
            className="zhxt-panorama-kind-tree"
          />
        )}
      </div>
    </div>
  );
}
